import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import { hasSubmitSucceeded, getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import UserCreateEditForm from 'components/settings/UserCreateEditForm';
import Button from 'components/common/Button';
import Prompt from 'components/common/Prompt';

import { fetchUser, clearUsers } from 'redux/modules/users';
import { fetchRoles, clearRoles } from 'redux/modules/roles';
import { fetchAccessPermissions } from 'redux/modules/accessPermissions';

import { appTitle, titleSeparator } from 'config/helmetSettings';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  toolbar: {
    marginBottom: 16,
  },
});

class UserCreateEdit extends Component {
  componentWillMount() {
    this.props.actions.clearUsers();
    this.props.actions.clearRoles();
  }

  componentDidMount() {
    const { variant, actions, match } = this.props;
    if (variant === 'edit') {
      actions.fetchUser({
        ID: match.params.id,
        triggerLoading: true,
      });
      actions.fetchAccessPermissions({
        triggerLoading: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { variant, loading, history, actions } = this.props;
    if (variant === 'edit') {
      if (loading > 0
        && nextProps.loading === 0) {
        if (!nextProps.user) {
          history.replace('/settings/users');
        } else {
          actions.fetchRoles({
            filters: [{
              name: 'ID',
              operation: 'in',
              val: nextProps.user.Roles.map(item => item.ID),
            }],
          });
        }
      }
    }
  }

  render() {
    const {
      user,
      history,
      loading,
      formValues,
      initialValues,
      submitSucceeded,
      variant,
      accessPermissions,
      roles,
      classes,
    } = this.props;
    const diffValues = objectDiff(formValues, initialValues);
    return (
      <Layout variant="settings">
        {(loading > 0 || (variant === 'edit' && (!user || roles.length === 0))) ? (
          <Progress />
        ) : (
          <Fragment>
            <Helmet>
              <title>
                {appTitle} {titleSeparator} Users {titleSeparator}
                {variant === 'create' ? ' Create User' : ''}
                {variant === 'edit' && user ? ` ${user['First Name']} ${user['Last Name']}` : ''}
              </title>
            </Helmet>
            {/* <Toolbar className={classes.toolbar} disableGutters>
              <Button
                nav
                href="/settings/users"
              >
                Users
              </Button>
              <Button
                nav
                href="/settings/roles"
              >
                Roles and Permissions
              </Button>
            </Toolbar> */}
            <UserCreateEditForm
              form={variant === 'create' ? 'userCreate' : `${user.ID}-userEdit`}
              variant={variant}
              initialValues={initialValues}
              formValues={formValues}
              accessPermissions={accessPermissions}
              onSubmitSuccess={() => {
                history.push('/settings/users');
              }}
            />
            <Prompt
              when={Object.keys(diffValues).length > 0 && !submitSucceeded}
              message="All the setups will be reset. Are you sure that you want to leave this page?"
            />
          </Fragment>
        )}
      </Layout>
    );
  }
}

UserCreateEdit.propTypes = {
  variant: PropTypes.oneOf(['create', 'edit']),
  user: PropTypes.shape({
    ID: PropTypes.number,
    Roles: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
    })).isRequired,
  }),
  roles: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    clearUsers: PropTypes.func.isRequired,
    fetchUser: PropTypes.func.isRequired,
    fetchAccessPermissions: PropTypes.func.isRequired,
    fetchRoles: PropTypes.func.isRequired,
    clearRoles: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    ID: PropTypes.number,
  }),
  initialValues: PropTypes.shape({
    ID: PropTypes.number,
  }),
  submitSucceeded: PropTypes.bool.isRequired,
  accessPermissions: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  classes: PropTypes.shape({
    toolbar: PropTypes.string.isRequired,
  }).isRequired,
};

UserCreateEdit.defaultProps = {
  user: null,
  variant: 'create',
  formValues: {},
  initialValues: {},
};

const mapStateToProps = (store, ownProps) => {
  const user = store.users.data.length > 0
    ? store.users.data.find(item => item.ID === Number(ownProps.match.params.id)) : null;
  const formName = ownProps.variant === 'create' || !user
    ? 'userCreate' : `${user.ID}-userEdit`;
  const formValues = getFormValues(formName)(store);
  const roles = store.roles.data;
  return {
    user,
    roles,
    accessPermissions: store.accessPermissions.data,
    loading: store.users.loading + store.accessPermissions.loading,
    submitSucceeded: hasSubmitSucceeded(formName)(store),
    formValues,
    initialValues: ownProps.variant === 'create' || !user || roles.length === 0
      ? {
        Active: 'true',
        Gender: 'Other',
      } : {
        ID: user.ID,
        'First Name': user['First Name'],
        'Last Name': user['Last Name'],
        'Mobile Phone': user['Mobile Phone'],
        Email: user.Email,
        Gender: user.Gender,
        Role: roles.map(item => ({
          label: item.Name,
          value: item.ID,
          accesses: item.Accesses.map(accessesItem => accessesItem.ID),
        })),
        Title: user.Title,
        ...user.Image['File Name'] ? {
          Image: {
            name: user.Image['File Name'],
            preview: `${user.Image['File Url']}${user.Image['File Name']}`,
          },
        } : {},
        Active: user.Active ? 'true' : 'false',
      },
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    clearUsers,
    fetchUser,
    fetchAccessPermissions,
    fetchRoles,
    clearRoles,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(UserCreateEdit),
);



// WEBPACK FOOTER //
// ./src/pages/settings/UserCreateEdit.js